/*
 * Public API Surface of angular-tags-input
 */

export * from './lib/un-added-tags.pipe';
export * from './lib/tags-input-interfaces';
export * from './lib/angular-tags-input.service';
export * from './lib/angular-tags-input.component';
export * from './lib/angular-tags-input.module';
export * from './lib/keyboard-active-class/keyboard-active-class.directive';
